import React, { Component } from 'react';
import { Col, Modal, ModalHeader, ModalBody, Row, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getAPI } from '../Base/API';
import { BlankCard } from '../Base/Common/CommonUIComponents';
import { handleNotification } from '../Base/Notification';
import moment from 'moment';

export class CcModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            block: true,
            pciBookingCardPreview: false,
            cc: {}
        };
    }

    componentDidMount() {
        const { toggle, reservationId } = this.props;
        
        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);

                    this.setState({ error: errorMessage, block: false }, _ => toggle('ccModal', null));
                }
                else if (data.response && data.response.length > 0) {
                    this.setState({ error: errorMessage, block: false, cc: data.response[0] });
                }
                else {
                    this.setState({ error: errorMessage, block: false });
                }
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }
        }, `/api/Rate/Reservation/v1/reservationCCView/${reservationId}`);
    }

    getPciBookingToken = () => {
        this.setState({ block: true }, () => {
            getAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState({ block: false });
                        return;
                    }
                    if (data.response && data.response.length > 0) {
                        this.toggleIframeModal(data.response[0]);
                        return;
                    }

                    this.setState({ error: errorMessage, block: false });
                }
                else this.setState({ error: errorMessage, block: false });
            }, '/api/hotel/PCIBooking/v1/payments/paycard/tempsession')
        });
    }

    toggleIframeModal = (sessionToken) => {
        this.setState(prevState => ({
            pciBookingCardPreview: !prevState.pciBookingCardPreview,
            sessionToken,
            block: false
        }))
    }


    render() {
        const { isOpen, toggle } = this.props;
        const { block, error, cc, pciBookingCardPreview } = this.state;

        return (
            <Modal isOpen={isOpen} toggle={_ => toggle('ccModal', null)}>
                <ModalHeader toggle={_ => toggle('ccModal', null)}>
                    <FormattedMessage id="ReservationDetail.CcData" />
                </ModalHeader>
                <ModalBody>
                    <BlankCard block={block} error={error}>
                        <Row className="mb-3 align-items-center">
                            <Col>
                                <h5>
                                    {
                                        cc.accesses ?
                                            <FormattedMessage id="ReservationDetail.AccessesDisplayMessage" values={{ accesses: cc.accesses + 1 }} />
                                            :
                                            ''
                                    }
                                </h5>
                            </Col>
                            {global.modules?.some(m => m === 'PCIBooking') && cc.tokenProvider === "PCIBooking" && cc.token ?
                                <Col className="text-right">
                                    <Button className="btn btn-host btn-sm" onClick={this.getPciBookingToken} title="PCI Booking Card Display">
                                        <i className="far fa-credit-card" />
                                    </Button>
                                </Col>
                            : ''}
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.Brand" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {cc.cardCode}
                                </span>
                            </Col>
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.CardNumber" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {cc.cardNumber}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.Last4" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {cc.lastDigits}
                                </span>
                            </Col>
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.ExpYear" />/<FormattedMessage id="Payments.ExpMonth" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {cc.expireDate}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.EffectiveDate" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {
                                        cc.effectiveDate ?
                                            moment(cc.effectiveDate).format("YYYY-MM-DD HH:mm:ss")
                                            :
                                            ''
                                    }
                                </span>
                            </Col>
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.SeriesCode" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {cc.seriesCode}
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <b>
                                    
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>

                                </span>
                            </Col>
                            <Col className="col-2">
                                <b>
                                    <FormattedMessage id="Payments.IsVirtualCc" />
                                </b>
                            </Col>
                            <Col className="col-4">
                                <span>
                                    {
                                        cc.isVirtualCc === undefined ?
                                            ''
                                            :
                                            cc.isVirtualCc ?
                                                <i className=" text-success fas fa-check"/>
                                                :
                                                <i className="text-danger fas fa-times" />
                                    }
                                </span>
                            </Col>
                        </Row>
                    </BlankCard>

                    {pciBookingCardPreview ?
                        <Modal isOpen={pciBookingCardPreview} toggle={this.toggleIframeModal} body className="modal-md" style={{ minWidth: '550px' }}>
                            <iframe src={`https://service.pcibooking.net/api/payments/paycard/${cc.token}/display?formatCardNumber=true&css=HeyCM&sessionToken=${this.state.sessionToken}`} width="100%" height="400px" className='border-0'></iframe>
                        </Modal>
                    : ''}

                </ModalBody>
            </Modal>
        );
    }
}